import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const swiperOptions = (slideCount) => ({
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 2000,
    loop: slideCount > 1, // Enable loop only if there are more than 1 slide
    observer: true,
    observeParents: true,
    initialSlide: 1,
    pagination: {
        el: '.swiper-dot-style1',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
    },
    autoplay: { delay: 9000 },
    breakpoints: {
        0: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        375: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        575: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        992: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        1200: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        1320: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
    },
});

export default function TestimonialSlider1() {
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        // Fetch testimonials from API
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/testimonials`)
            .then(response => {
                setTestimonials(response.data);
            })
            .catch(error => {
                console.error('Error fetching testimonials:', error);
            });
    }, []);

    return (
        <Swiper {...swiperOptions(testimonials.length + 1)} className="thm-swiper__slider swiper-container">
            {/* Static testimonial slide */}
            <SwiperSlide key="static">
                <div className="testimonial-one__single">
                    <div className="testimonial-one__quote">
                        <span className="icon-quote" />
                    </div>
                    <div className="testimonial-one__client-img">
                        <img
                            src="https://i1.rgstatic.net/ii/profile.image/893222603735040-1589972272034_Q512/Rohan-Sharma-12.jpg" // update with your static image path
                            alt="Static Testimonial"
                            style={{ width: "100px", height: "100px" }}
                        />
                    </div>
                    <div className="testimonial-one__ratting">
                        {/* Assuming a 5-star rating for static testimonial */}
                        {[...Array(5)].map((_, i) => (
                            <span className="icon-star" key={i} />
                        ))}
                    </div>
                    <h3 className="testimonial-one__client-name">Rohan Sharma</h3>
                    <p className="testimonial-one__client-sub-title">FlimMaking Student</p>
                    <p className="testimonial-one__text">"Sunrising Cinevision Academy is truly a game-changer for aspiring filmmakers."</p>
                </div>
            </SwiperSlide>
            {testimonials.map(testimonial => (
                <SwiperSlide key={testimonial.id} className="swiper-slide">
                    <div className="testimonial-one__single">
                        <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div>
                        <div className="testimonial-one__client-img">
                            <img
                                src={testimonial.image}
                                alt={`Testimonial from ${testimonial.client_name}`}
                                style={{ width: "100px", height: "100px" }}
                            />
                        </div>
                        <div className="testimonial-one__ratting">
                            {[...Array(testimonial.rating)].map((_, i) => (
                                <span
                                    className={`icon-star${i === testimonial.rating ? " last-star" : ""}`}
                                    key={i}
                                />
                            ))}
                        </div>
                        <h3 className="testimonial-one__client-name">
                            {testimonial.client_name}
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            {testimonial.client_title}
                        </p>
                        <p className="testimonial-one__text">
                            {testimonial.testimonial_text}
                        </p>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
